import { IProjectStore } from "./index";

export default {
  form: {
    name: "",
    phone: "",
    email: "",
    notes: "",
    agree: false,
    fastOrder: false,
  },
  project: {},
  id: null,
  cartId: null,
  date: null,
  cart: [],
  history: [],
  loaded: false,
  loading: false,
  editable: true,
  zoom: 1,
  centred: true,
  order: {},
  contentLoading: true,
  selectedAttributes: [],
  attributes: [] as any,
} as IProjectStore;
